import { useSetAtom } from "jotai";
import { providerIsHelpModalOpenAtom } from "../state";
import { sendLoggingEvents, TrackingEvents } from "../../events";
import { useCallback } from "react";

export function useOpenHelpModalCallback() {
  const setIsHelpModalOpen = useSetAtom(providerIsHelpModalOpenAtom);

  return useCallback(() => {
    setIsHelpModalOpen(true);
    sendLoggingEvents(TrackingEvents.ANY_HELP_REQUEST);
    sendLoggingEvents(TrackingEvents.PROVIDER_HELP_REQUEST);
  }, [setIsHelpModalOpen]);
}
